import React from 'react';
import { compose, mapProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { FIRST_LAST } from 'selectors/formatName/selector';
import { getAssessmentParticipants } from 'selectors/assessment/selector';
import { getCurrentUser as getCurrentUserSelector } from 'selectors/user/selector';
import { getCurrentUser } from 'graphql/operations';
import { CheckboxGroup } from 'components/common/CheckboxGroup/CheckboxGroup';
import FormatName from 'components/threepp/FormatName/FormatName';
import { sortUsersByCurrentFirst } from 'utils/functions';
import './AssessmentParticipantFilter.scss';

export const AssessmentParticipantFilter = props => {
  const { currentUser, checked, onChange, participants = [], t } = props;

  const sortedParticipants = [...participants].sort(sortUsersByCurrentFirst(currentUser));

  const participantOptions = sortedParticipants.map(participant => ({
    value: participant.email,
    label: <FormatName user={participant} format={FIRST_LAST} />
  }));

  // Unassigned should appear last
  participantOptions.push({
    value: 'unassigned',
    label: t('assessment.filters.participantFilter.unassigned')
  });

  return (
    <div className="outer-filter-section-padding">
      <div className="participant-filter-section">
        <p id="participant_title" className="participant-filter-title">
          {t('assessment.filters.participantFilter.title')}
        </p>
      </div>
      <div>
        <CheckboxGroup className=".threepp-checkbox-wrapper" options={participantOptions} checked={checked} onChange={onChange} />
      </div>
    </div>
  );
};

AssessmentParticipantFilter.propTypes = {
  t: PropTypes.func.isRequired,
  checked: PropTypes.oneOfType([PropTypes.array]),
  onChange: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({ email: PropTypes.string.isRequired }).isRequired,
  participants: PropTypes.oneOfType([PropTypes.array]).isRequired
};

AssessmentParticipantFilter.defaultProps = {
  checked: []
};

export const AssessmentParticipantFilterHoC = compose(
  withRouter,
  withTranslation(),
  graphql(getCurrentUser, { name: 'getCurrentUser' }),
  mapProps(props => ({
    t: props.t,
    checked: props.checked,
    onChange: props.onChange,
    currentUser: getCurrentUserSelector(props),
    participants: getAssessmentParticipants(props)
  }))
);

export default AssessmentParticipantFilterHoC(AssessmentParticipantFilter);
